(function () {
  'use strict';
  if (window.__erP3Init) return;
  window.__erP3Init = true;
  function erInit() {

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refreshCount() {
    if (typeof window.erUpdateCartCount === 'function') { window.erUpdateCartCount(); return; }
    getCart().then(function (cart) {
      document.querySelectorAll('[data-er-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
  }
  function toast(msg) {
    var t = document.querySelector('[data-er-toast]');
    if (!t) { t = document.createElement('div'); t.className = 'er-toast'; t.setAttribute('data-er-toast',''); document.body.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function(){ t.classList.add('is-visible'); });
    clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- SINGLE-USE KIT CODES (Jul 2026) ----------
     The old reusable RAVEKIT code was guessable (and printed in the DOM), so
     it is gone. Now:
       - LIVE shoppers: a random SINGLE-USE code is pulled from the Apps
         Script dispenser (tier 'kit', backed by the Admin pool
         "ER Rave Kit · 20% off (single-use)") the moment a full kit is added.
       - Preview/test themes: window.ERA_TEST_CODES.kit (injected by
         era-owl-arcade.liquid behind a Liquid theme.role gate) — reusable and
         unguessable, so playtesting never burns pool codes. The gated block
         never renders on the published theme, so live page source contains
         NO reusable code string.
     NOTE: the dispenser must know the 'kit' tier before this theme is
     published (add the KIT20-* pool to the "Everything Rave Discount Codes"
     Apps Script). Until then live kit adds get an honest failure toast. */
  var ER_DISPENSER = 'https://script.google.com/macros/s/AKfycbwacRnb8y70XzChTuMp_V-eH6IiAUCJATKFns32yqCvrFigIOKUTNnZdt6-pjNZMbGgSg/exec';
  function erKitTestCode() {
    return (window.ERA_TEST_CODES && window.ERA_TEST_CODES.kit) ? String(window.ERA_TEST_CODES.kit) : '';
  }
  function erKitJsonp(done) {
    var cb = 'erKitCB' + Date.now() + Math.floor(Math.random() * 100000), s, fin = false;
    var t = setTimeout(function () { finish(null); }, 12000);
    function finish(res) { if (fin) return; fin = true; clearTimeout(t); try { delete window[cb]; } catch (e) { window[cb] = undefined; } if (s && s.parentNode) s.parentNode.removeChild(s); done(res); }
    window[cb] = function (res) { finish(res); };
    s = document.createElement('script'); s.onerror = function () { finish(null); };
    s.src = ER_DISPENSER + '?tier=kit&callback=' + cb;
    document.body.appendChild(s);
  }
  function erGetKitCode(done) {
    var tc = erKitTestCode();
    if (tc) { done(tc); return; }
    erKitJsonp(function (res) { done(res && res.ok && res.code ? String(res.code) : null); });
  }

  /* ---------- KIT DISCOUNT GUARD ----------
     The kit builder stores the chosen variant ids + the DISPENSED discount
     code as cart attributes. On EVERY cart mutation (add/change/update, incl.
     Dawn's own cart page and drawer) we re-check: kit intact -> code applied;
     kit broken -> code cleared. Keeps totals honest when items are removed.

     NOTE: this guard is a UX convenience, NOT enforcement. It runs in the
     shopper's browser, so it can be bypassed. The real enforcement is on the
     discount itself in Admin: pool codes are usage-limit 1, once per
     customer. */
  var guardBusy = false;

  function kitCodeName() {
    /* Only used when a cart carries no er_kit_code attribute. There is no
       shared reusable kit code any more, so fall back to the (non-live-only)
       test code or nothing. */
    return erKitTestCode().toUpperCase();
  }
  function appliedCodes(cart) {
    return (cart.cart_level_discount_applications || []).map(function (a) {
      return String((a && a.title) || '').toUpperCase();
    }).filter(Boolean);
  }
  /* Drop ONE code without collateral damage. /cart/update.js takes the full set
     of codes, so we re-send everything except the kit code (or '' if that was
     the only one). This is why we don't just send {discount:''} - that would
     also wipe a code the shopper legitimately earned in the owl game. */
  function dropCode(cart, codeToDrop) {
    var keep = appliedCodes(cart).filter(function (t) { return t !== codeToDrop; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: keep.join(',') })
    });
  }
  function clearKitAttrs() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { er_kit: '', er_kit_code: '' } })
    });
  }
  function afterChange(msg) {
    guardBusy = false;
    try { sessionStorage.setItem('erKitDisc', '0'); } catch (e) {}
    if (location.pathname.indexOf('/cart') === 0) { location.reload(); }
    else { refreshCount(); if (msg) toast(msg); }
  }

  function checkKitDiscount() {
    if (guardBusy) return;
    getCart().then(function (cart) {
      var attrs = cart.attributes || {};
      var idstr = attrs.er_kit ? String(attrs.er_kit) : '';
      var code = attrs.er_kit_code ? String(attrs.er_kit_code) : '';
      var applied = appliedCodes(cart);
      var kitCode = (code ? String(code) : kitCodeName()).toUpperCase();
      var kitApplied = kitCode ? applied.indexOf(kitCode) !== -1 : false;

      /* No kit attributes. Nothing on this cart qualifies for the kit deal, so
         the kit code must not be on it. It only ever removes the kit code - an
         earned owl-game code is left alone. */
      if (!idstr || !code) {
        if (kitApplied) {
          guardBusy = true;
          dropCode(cart, kitCode)
            .then(function () { afterChange('Kit discount removed — the kit isn\'t complete'); })
            .catch(function () { guardBusy = false; });
        }
        return;
      }

      var ids = idstr.split(',').filter(Boolean);
      var present = cart.items.map(function (i) { return String(i.variant_id); });
      var intact = ids.length > 0 && ids.every(function (id) { return present.indexOf(id) !== -1; });

      /* Drive off the cart's ACTUAL state rather than a sessionStorage flag. */
      if (!intact) {
        if (kitApplied || idstr || code) {
          guardBusy = true;
          dropCode(cart, kitCode)
            .then(clearKitAttrs)
            .then(function () { afterChange('Kit discount removed — a kit item left the cart'); })
            .catch(function () { guardBusy = false; });
        }
        return;
      }

      /* Kit is intact and the code isn't on. Re-apply the SAME dispensed code
         stored in the cart attribute - but never stomp a code the shopper
         already has (e.g. an owl-game reward that may be better). */
      if (!kitApplied && applied.length === 0) {
        guardBusy = true;
        fetch('/discount/' + encodeURIComponent(code))
          .then(function () {
            guardBusy = false;
            try { sessionStorage.setItem('erKitDisc', '1'); } catch (e) {}
            if (location.pathname.indexOf('/cart') === 0) { location.reload(); }
            else { toast('Kit complete — discount applied'); }
          })
          .catch(function () { guardBusy = false; });
      }
    }).catch(function () {});
  }
  (function hookCartMutations() {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var p = _fetch.apply(this, arguments);
      try {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        if (/\/cart\/(change|update|add)/.test(url) && !guardBusy) {
          p.then(function () { setTimeout(checkKitDiscount, 400); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      try {
        if (/\/cart\/(change|update|add)/.test(String(url)) && !guardBusy) {
          this.addEventListener('loadend', function () { setTimeout(checkKitDiscount, 400); });
        }
      } catch (e) {}
      return _open.apply(this, arguments);
    };
  })();
  setTimeout(checkKitDiscount, 600);

  /* ---------- ORDER BUMP ---------- */
  var bump = document.querySelector('[data-er-bump]');
  if (bump) {
    var bumpVariant = bump.getAttribute('data-variant-id');
    var bumpBtn = bump.querySelector('[data-er-bump-add]');
    function syncBump() {
      getCart().then(function (cart) {
        if (cart.item_count === 0) { bump.style.display = 'none'; return; }
        var inCart = cart.items.some(function (i) { return String(i.variant_id) === String(bumpVariant); });
        bump.style.display = inCart ? 'none' : '';
      });
    }
    if (bumpBtn) {
      bumpBtn.addEventListener('click', function () {
        bumpBtn.disabled = true; var orig = bumpBtn.textContent; bumpBtn.textContent = 'Adding…';
        fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items:[{ id: parseInt(bumpVariant,10), quantity:1 }] }) })
          .then(function(r){ if(!r.ok) return r.json().then(function(x){throw x;}); return r.json(); })
          .then(function(){ toast('Hydration sample added'); refreshCount(); bump.style.display='none'; })
          .catch(function(err){ bumpBtn.disabled=false; bumpBtn.textContent=orig; toast((err&&err.description)?err.description:'Could not add'); });
      });
    }
    syncBump();
    document.addEventListener('click', function (e) { if (e.target.closest('[data-er-add]')) setTimeout(syncBump, 600); });
  }

  /* ---------- SURVIVAL KIT SWAP BANNER ---------- */
  var swap = document.querySelector('[data-er-swap]');
  if (swap) {
    var trigEls = swap.getAttribute('data-trigger-ids') || '';
    var triggerIds = trigEls.split(',').map(function(s){return s.trim();}).filter(Boolean);
    var kitVariant = swap.getAttribute('data-kit-variant');
    var swapBtn = swap.querySelector('[data-er-swap-go]');
    var dismissBtn = swap.querySelector('[data-er-swap-dismiss]');
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('erSwapDismissed') === '1'; } catch(e){}
    function checkSwap() {
      if (dismissed) { swap.classList.remove('is-visible'); return; }
      getCart().then(function (cart) {
        var presentVariants = cart.items.map(function(i){ return String(i.variant_id); });
        var hasAll = triggerIds.every(function(id){ return presentVariants.indexOf(id) !== -1; });
        var hasKit = presentVariants.indexOf(String(kitVariant)) !== -1;
        if (hasAll && !hasKit) swap.classList.add('is-visible');
        else swap.classList.remove('is-visible');
      });
    }
    if (swapBtn) {
      swapBtn.addEventListener('click', function () {
        swapBtn.disabled = true; var orig = swapBtn.textContent; swapBtn.textContent = 'Swapping…';
        getCart().then(function (cart) {
          var updates = {};
          cart.items.forEach(function (i) { if (triggerIds.indexOf(String(i.variant_id)) !== -1) updates[i.variant_id] = 0; });
          return fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ updates: updates }) }).then(function(r){return r.json();});
        }).then(function () {
          return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ items:[{ id: parseInt(kitVariant,10), quantity:1 }] }) }).then(function(r){ if(!r.ok) return r.json().then(function(x){throw x;}); return r.json(); });
        }).then(function () {
          toast('Swapped to the Rave Survival Kit — you saved!');
          refreshCount(); swap.classList.remove('is-visible');
          setTimeout(function(){ window.location.href = '/cart'; }, 900);
        }).catch(function(err){ swapBtn.disabled=false; swapBtn.textContent=orig; toast((err&&err.description)?err.description:'Swap failed'); });
      });
    }
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        dismissed = true; try { sessionStorage.setItem('erSwapDismissed','1'); } catch(e){}
        swap.classList.remove('is-visible');
      });
    }
    checkSwap();
    document.addEventListener('click', function (e) { if (e.target.closest('[data-er-add]') || e.target.closest('[data-er-kit-add]')) setTimeout(checkSwap, 700); });
  }

  /* ---------- BUILD YOUR RAVE KIT (paginated wizard) ---------- */
  var kit = document.querySelector('[data-er-kit]');
  if (kit) {
    var steps = [].slice.call(kit.querySelectorAll('[data-er-kit-step]'));
    var totalSteps = steps.length;
    var current = 0;
    var DISCOUNT = parseFloat(kit.getAttribute('data-discount-pct') || '0.2');
    var dotsWrap = kit.querySelector('[data-er-kit-dots]');
    var stepLabel = kit.querySelector('[data-er-kit-steplabel]');
    var backBtn = kit.querySelector('[data-er-kit-back]');
    var nextBtn = kit.querySelector('[data-er-kit-next]');
    var addBtn = kit.querySelector('[data-er-kit-add]');
    var totalEl = kit.querySelector('[data-er-kit-total]');
    var saveEl = kit.querySelector('[data-er-kit-save]');
    var hintEl = kit.querySelector('[data-er-kit-hint]');

    function money(c) { return '$' + (c / 100).toFixed(2); }
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < totalSteps; i++) {
        var d = document.createElement('span');
        d.className = 'er-kit__dot' + (i === current ? ' is-active' : '');
        dotsWrap.appendChild(d);
      }
    }
    function chosenCount() {
      var n = 0;
      steps.forEach(function (s) { var sel = s.querySelector('input[type=radio]:checked'); if (sel && sel.value !== 'skip') n++; });
      return n;
    }
    function rawTotal() {
      var t = 0;
      steps.forEach(function (s) { var sel = s.querySelector('input[type=radio]:checked'); if (sel && sel.value !== 'skip') t += parseInt(sel.getAttribute('data-price'), 10) || 0; });
      return t;
    }
    function updateTotals() {
      var t = rawTotal();
      var full = chosenCount() === totalSteps;
      if (totalEl) {
        if (full && DISCOUNT > 0) {
          var disc = Math.round(t * DISCOUNT);
          totalEl.innerHTML = '<span class="er-kit__total-was">' + money(t) + '</span> ' + money(t - disc);
          if (saveEl) { saveEl.style.display = ''; saveEl.textContent = 'Full stack — you save ' + money(disc); }
        } else {
          totalEl.textContent = money(t);
          if (saveEl) { saveEl.style.display = ''; saveEl.textContent = chosenCount() === 0 ? '' : ('Complete all ' + totalSteps + ' steps to save ' + Math.round(DISCOUNT*100) + '%'); }
        }
      }
    }
    function stepHasChoice(i) { return !!steps[i].querySelector('input[type=radio]:checked'); }
    function refreshNav() {
      if (nextBtn) nextBtn.disabled = !stepHasChoice(current);
      if (addBtn) addBtn.disabled = chosenCount() === 0;
      if (hintEl) hintEl.textContent = !stepHasChoice(current) ? 'Make a selection to continue' : (chosenCount() + ' item' + (chosenCount() > 1 ? 's' : '') + ' in your kit');
    }
    function syncArrows() {
      [].forEach.call(kit.querySelectorAll('[data-er-kit-rowwrap]'), function (wrap) {
        var row = wrap.querySelector('[data-er-kit-row]');
        if (!row) return;
        var over = row.scrollWidth > row.clientWidth + 4;
        [].forEach.call(wrap.querySelectorAll('[data-er-kit-scroll]'), function (a) { a.classList.toggle('is-on', over); });
      });
    }
    kit.addEventListener('click', function (e) {
      var arrow = e.target.closest('[data-er-kit-scroll]');
      if (!arrow) return;
      var wrap = arrow.closest('[data-er-kit-rowwrap]');
      var row = wrap && wrap.querySelector('[data-er-kit-row]');
      if (!row) return;
      var tile = row.querySelector('.er-kit__tile');
      var step = (tile ? tile.offsetWidth : 210) + 12;
      row.scrollBy({ left: arrow.getAttribute('data-er-kit-scroll') === 'next' ? step : -step, behavior: 'smooth' });
    });
    window.addEventListener('resize', function () { requestAnimationFrame(syncArrows); });
    function showStep(i) {
      current = Math.max(0, Math.min(totalSteps - 1, i));
      steps.forEach(function (s, idx) { if (idx === current) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', ''); } });
      buildDots();
      if (stepLabel) stepLabel.textContent = 'Step ' + (current + 1) + ' of ' + totalSteps;
      if (backBtn) { if (current === 0) backBtn.setAttribute('hidden', ''); else backBtn.removeAttribute('hidden'); }
      var last = current === totalSteps - 1;
      if (nextBtn) { if (last) nextBtn.setAttribute('hidden', ''); else nextBtn.removeAttribute('hidden'); }
      if (addBtn) { if (last) addBtn.removeAttribute('hidden'); else addBtn.setAttribute('hidden', ''); }
      refreshNav();
      requestAnimationFrame(syncArrows);
    }
    kit.addEventListener('change', function (e) {
      if (e.target.matches('input[type=radio]')) {
        var step = e.target.closest('[data-er-kit-step]');
        if (step) step.querySelectorAll('.er-kit__tile').forEach(function (o) { o.classList.remove('is-selected'); });
        var opt = e.target.closest('.er-kit__tile');
        if (opt) opt.classList.add('is-selected');
        updateTotals();
        refreshNav();
        if (current < totalSteps - 1) { setTimeout(function () { showStep(current + 1); }, 320); }
      }
    });
    if (nextBtn) nextBtn.addEventListener('click', function () { if (stepHasChoice(current)) showStep(current + 1); });
    if (backBtn) backBtn.addEventListener('click', function () { showStep(current - 1); });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        steps.forEach(function (s) { var sel = s.querySelector('input[type=radio]:checked'); if (sel && sel.value !== 'skip') items.push({ id: parseInt(sel.value, 10), quantity: 1 }); });
        if (!items.length) return;
        var full = chosenCount() === totalSteps;
        addBtn.disabled = true; var orig = addBtn.textContent; addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
          .then(function () {
            if (full && DISCOUNT > 0) {
              /* Full stack: burn ONE single-use code (live) or apply the
                 reusable test code (preview). The dispensed code is stored on
                 the cart so the guard re-applies/drops that exact code. */
              guardBusy = true;
              var ids = items.map(function (it) { return it.id; }).join(',');
              erGetKitCode(function (kcode) {
                if (!kcode) {
                  guardBusy = false;
                  toast('Kit added — we couldn\'t fetch your kit discount right now. Try again in a moment.');
                  refreshCount();
                  addBtn.textContent = 'Added ✓';
                  setTimeout(function () { addBtn.textContent = orig; addBtn.disabled = false; }, 1500);
                  return;
                }
                fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { er_kit: ids, er_kit_code: kcode } }) })
                  .then(function () { return fetch('/discount/' + encodeURIComponent(kcode)); })
                  .then(function () {
                    guardBusy = false;
                    try { sessionStorage.setItem('erKitDisc', '1'); } catch (e) {}
                    toast('Kit added — ' + Math.round(DISCOUNT * 100) + '% discount applied');
                    refreshCount();
                    setTimeout(function () { window.location.href = '/cart'; }, 1000);
                  })
                  .catch(function () {
                    guardBusy = false;
                    addBtn.disabled = false; addBtn.textContent = orig;
                    toast('Kit added — the discount could not be applied');
                  });
              });
              return;
            }
            toast('Your kit is in the cart — ' + items.length + ' item' + (items.length > 1 ? 's' : ''));
            refreshCount();
            addBtn.textContent = 'Added ✓';
            setTimeout(function () { addBtn.textContent = orig; addBtn.disabled = false; }, 1500);
          })
          .catch(function (err) { guardBusy = false; addBtn.disabled = false; addBtn.textContent = orig;
            toast((err && err.description) ? err.description : 'Could not add kit');
          });
      });
    }
    showStep(0);
    updateTotals();
  }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', erInit); } else { erInit(); }
})();
